import { Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'
import { getRGBA } from 'utils/color'

const contentMaxWidth = 1366

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: '1.5rem',
    width: 'auto !important',
  },

  box: {
    width: 'auto !important',
    maxWidth: contentMaxWidth,
    margin: 0,
    padding: '1rem 1.25rem',
    backgroundColor: '#FFFFFF',
    display: 'flex',
    flexDirection: 'column',
    gap: '0.875rem',
    borderRadius: '0.5rem',
    boxShadow: '0 0 4px rgba(0, 0, 0, 0.1)',
    overflow: 'hidden',
  },

  boxLoading: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '5.625rem',
    gap: '1rem',

    '& span': {
      fontFamily: 'Nunito',
      fontSize: '1rem',
      lineHeight: '1.5rem',
    },
  },

  actions: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
    justifyContent: 'flex-end',
    gap: '0.5rem',
  },

  submitButton: {
    height: '2.25rem !important',
    width: 'clamp(6.125rem,6.125rem,6.125rem) !important',
    padding: '1rem !important',
  },

  cancelButton: {
    height: '2.25rem !important',
    width: 'clamp(6.125rem,6.125rem,6.125rem) !important',
    padding: '1rem !important',
    color: '#BA1A1A !important',
    border: `1px solid ${getRGBA('#BA1A1A', 0.5)} !important`,

    '&:hover': {
      backgroundColor: getRGBA('#BA1A1A', 0.1),
    },
  },
}))

export { useStyles }
